export default __webpack_public_path__ + "static/media/client-25.a2139a85.webp";